import { render } from "./BackToTopButton.vue?vue&type=template&id=f5356046&scoped=true"
import script from "./BackToTopButton.vue?vue&type=script&lang=js"
export * from "./BackToTopButton.vue?vue&type=script&lang=js"

import "./BackToTopButton.vue?vue&type=style&index=0&id=f5356046&lang=less&scoped=true"

import exportComponent from "/builds/sun-chemical/color-materials/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5356046"]])

export default __exports__